import zh from '@/locales/zh.json'
import en from '@/locales/en.json'

const Lang = {
  zh,
  en,
}
class searchFrom {
  constructor(type, lanuage = 0) {
    if (type === 'form') {
      this.oldPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
    } else if (type === 'rule') {
      this.oldPassword = [
        {
          required: true,
          message: Lang[lanuage === 1 ? `en` : `zh`].ple_ent_oldPassword,
          trigger: 'blur',
        },
      ]
      this.newPassword = [
        {
          required: true,
          message: Lang[lanuage === 1 ? `en` : `zh`].ple_ent_newPassword,
          trigger: 'blur',
        },
      ]
      this.confirmPassword = [
        {
          required: true,
          message: Lang[lanuage === 1 ? `en` : `zh`].ple_ent_confirmPassword,
          trigger: 'blur',
        },
      ]
    }
  }
}
export default searchFrom
